import { useMutation } from "@tanstack/react-query";
import { putUpdateCompany } from "api/index";
import { PrlObjectUpdateCompanyPrlRequest } from "types/api/api";
import { AxiosRequestHeaders } from "axios";

// eslint-disable-next-line
const useMutateUpdateCompanyPrl = (options?: any) => {
  return useMutation(
    ({
      payload,
      id,
      headers
    }: {
      payload: PrlObjectUpdateCompanyPrlRequest;
      id: string;
      headers: AxiosRequestHeaders;
    }) => putUpdateCompany(payload, id, headers),
    options
  );
};

export default useMutateUpdateCompanyPrl;
